"use strict";
exports.__esModule = true;
require('../ignorance-board/ignorance-board.component.css');
var angular = require("angular");
var inav_utils_service_1 = require("../../../components/utils/inav-utils.service");
var issue_list_1 = require("../../../components/utils/issue-list/issue-list");
function componentFromStr(numStr, percent) {
    var num = Math.max(0, parseInt(numStr, 10));
    return percent ?
        Math.floor(255 * Math.min(100, num) / 100) : Math.min(255, num);
}
function rgbToHex(rgb) {
    if (rgb.indexOf('rgb') == -1) {
        return null;
    }
    var rgbRegex = /^rgb\(\s*(-?\d+)(%?)\s*,\s*(-?\d+)(%?)\s*,\s*(-?\d+)(%?)\s*\)$/;
    var result, r, g, b, hex = "";
    if ((result = rgbRegex.exec(rgb))) {
        r = componentFromStr(result[1], result[2]);
        g = componentFromStr(result[3], result[4]);
        b = componentFromStr(result[5], result[6]);
        hex = "#" + (0x1000000 + (r << 16) + (g << 8) + b).toString(16).slice(1);
    }
    return hex;
}
function getDropDetails(ev) {
    ev.preventDefault();
    var data = ev.originalEvent.dataTransfer.getData('text/plain');
    var draggable = document.getElementById(data);
    var textarea = draggable.getElementsByTagName('span');
    var content = textarea[0].innerHTML;
    var issueType = draggable.getAttribute("name");
    var issueId = draggable.getAttribute("id");
    // let stickyColor = rgbToHex(draggable.style.backgroundColor);
    return { content: content, issueType: issueType, issueId: issueId };
}
function updatedAt() {
    return new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
}
var IgnoranceBoardComponent = /** @class */ (function () {
    function IgnoranceBoardComponent($rootScope, $scope, $timeout) {
        this.items = [];
        this.selectedIssue = null;
        this.selectedIssueCopy = null;
        this.selectedIssueList = null;
        this.disableEdit = false;
        this.issueConfig = {};
        this.stickyList = {};
        // static updateIgnoranceIn (issueTypeList, issueId, ignorance=null) {
        //     for (let i = 0 ; i < issueTypeList.length ; i++) {
        //         if (issueId == issueTypeList[i]._id) {
        //             issueTypeList[i]['ignorance'] = ignorance ? ignorance : 0 ;
        //             issueTypeList[i]['updatedAt'] = updatedAt();
        //             break;
        //         }
        //     }
        // }
        this.isOverflown = function (_a) {
            var clientHeight = _a.clientHeight, scrollHeight = _a.scrollHeight;
            return scrollHeight > clientHeight;
        };
        // This constructor is necessary for inject scope and timeout.
        var ctrl = this;
        ctrl.$scope = $scope;
        ctrl.utilsService = new inav_utils_service_1.UtilsService(issue_list_1.IssueListEnum.DEFAULT);
        ctrl.issueType = ctrl.utilsService.issueType;
        ctrl.initValues();
        ctrl.initListeners();
        ctrl.$timeout = $timeout;
        ctrl.options = { show: true, id: -1 };
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        $timeout();
    }
    IgnoranceBoardComponent.prototype.initListeners = function () {
        var ctrl = this;
        var dropZoneLength = 10;
        ctrl.$scope.$on('command:IGNORANCE_BOARD', function (event, args) {
            ctrl.disableEdit = (args.node.permissions == 'r');
            ctrl.initComponent(event, args);
            ctrl.$scope.$emit('workbench:loading', { 'load': false });
        });
        var _loop_1 = function (dropIndex) {
            ctrl.$scope.$on('Drop' + dropIndex, function (event, args) {
                ctrl.setIssueDetails(dropIndex, args);
                console.log(event);
            });
        };
        for (var dropIndex = 0; dropIndex < dropZoneLength; dropIndex++) {
            _loop_1(dropIndex);
        }
    };
    IgnoranceBoardComponent.prototype.initValues = function () {
        var ctrl = this;
        for (var index = 0; index < 10; index++) {
            ctrl.items[index] = [];
        }
    };
    IgnoranceBoardComponent.prototype.setIssueDetails = function (dropIndex, args) {
        var ctrl = this;
        console.log(dropIndex);
        ctrl.updateIgGrid(args._id, dropIndex);
        var issueData = ctrl.removeAndReturnChangedIgnorance(args._id);
        // issueData['ignorance'] = dropIndex;
        // issueData['name'] = args.issue;
        ctrl.items[dropIndex].push(issueData);
        // ctrl.items[dropIndex].push({name: args.issue, ignorance: dropIndex, impact: 0, type: args.type});
        ctrl.saveIgnorance();
        ctrl.$scope.$apply();
    };
    IgnoranceBoardComponent.prototype.closeDialog = function (isSaveDFV) {
        var ctrl = this;
        ctrl.selectedIssue = null;
    };
    IgnoranceBoardComponent.prototype.removeAndReturnChangedIgnorance = function (issueId) {
        var ctrl = this;
        var res = {};
        var allItemList = [ctrl.items[9], ctrl.items[8], ctrl.items[7], ctrl.items[6], ctrl.items[5], ctrl.items[4], ctrl.items[3], ctrl.items[2], ctrl.items[1], ctrl.items[0]];
        for (var i = 0; i < allItemList.length; i++) {
            var itemGrid = allItemList[i];
            for (var j = 0; j < itemGrid.length; j++) {
                if (issueId == itemGrid[j]._id) {
                    res = angular.copy(itemGrid[j]);
                    itemGrid.splice(j, 1);
                    return res;
                    // break;
                }
            }
        }
        return res;
    };
    IgnoranceBoardComponent.prototype.updateIgGrid = function (issueId, igScore) {
        var ctrl = this;
        ctrl.items.forEach(function (x) {
            x.forEach(function (issue) {
                if (issue._id == issueId) {
                    issue['ignorance'] = igScore ? igScore : 0;
                    issue['updatedAt'] = updatedAt();
                }
            });
        });
        // IgnoranceBoardComponent.updateIgnoranceIn(ctrl.defaultList, issueId, igScore);
        // IgnoranceBoardComponent.updateIgnoranceIn(ctrl.desirability, issueId, igScore);
        // IgnoranceBoardComponent.updateIgnoranceIn(ctrl.feasibility, issueId, igScore);
        // IgnoranceBoardComponent.updateIgnoranceIn(ctrl.viability, issueId, igScore);
        // IgnoranceBoardComponent.updateIgnoranceIn(ctrl.strengths, issueId, igScore);
        // IgnoranceBoardComponent.updateIgnoranceIn(ctrl.weaknesses, issueId, igScore);
        // IgnoranceBoardComponent.updateIgnoranceIn(ctrl.opportunities, issueId, igScore);
        // IgnoranceBoardComponent.updateIgnoranceIn(ctrl.threats, issueId, igScore);
    };
    IgnoranceBoardComponent.prototype.getFontSize = function (id, stickyIndex) {
        var ctrl = this;
        var stickyID = id + stickyIndex;
        var element = document.getElementById(stickyID);
        var i = 14;
        var minSize = 12;
        if (!ctrl.isOverflown(element)) {
            element.style.fontSize = "14px";
        }
        else if (ctrl.isOverflown(element) && i > minSize) {
            i -= 2;
            element.style.fontSize = i + "px";
        }
    };
    IgnoranceBoardComponent.prototype.onSaveSticky = function () {
        var ctrl = this;
        // const id = ctrl.selectedIssue._id;
        // const index = ctrl.selectedIssue.index;
        // ctrl.items[ctrl.selectedIssue.ignorance][index] = ctrl.selectedIssue;
        // ctrl.updateIgGrid(id, index);
        // const issueData = ctrl.removeAndReturnChangedIgnorance(id);
        // ctrl.items[index].push(issueData);
        ctrl.saveIgnorance();
        ctrl.selectedIssue = null;
        // ctrl.$scope.$apply();
    };
    IgnoranceBoardComponent.prototype.onSetStickyHeight = function (id) {
        var element = document.getElementById(id);
        element.style.height = "1px";
        element.style.height = element.scrollHeight + 5 + "px";
    };
    // onStickyChange(id, stickyIndex, name){
    //     const ctrl = this;
    //     ctrl.updateChangeDate(name);
    //     ctrl.getFontSize(id, stickyIndex);
    //     ctrl.saveIgnorance();
    // }
    // updateChangeDate(issueId) {
    //     const ctrl = this;
    //     IgnoranceBoardComponent.updateIgnoranceIn(ctrl.desirability, issueId);
    //     IgnoranceBoardComponent.updateIgnoranceIn(ctrl.feasibility, issueId);
    //     IgnoranceBoardComponent.updateIgnoranceIn(ctrl.viability, issueId);
    //     IgnoranceBoardComponent.updateIgnoranceIn(ctrl.defaultList, issueId);
    //     IgnoranceBoardComponent.updateIgnoranceIn(ctrl.strengths, issueId);
    //     IgnoranceBoardComponent.updateIgnoranceIn(ctrl.weaknesses, issueId);
    //     IgnoranceBoardComponent.updateIgnoranceIn(ctrl.opportunities, issueId);
    //     IgnoranceBoardComponent.updateIgnoranceIn(ctrl.threats, issueId);
    // }
    // addSticky() {
    //     const ctrl = this;
    //     ctrl.defaultList.unshift(ctrl.utilsService.getNewSticky());
    //     ctrl.items[0].unshift(ctrl.defaultList[0]);
    //     ctrl.saveIgnorance();
    // }
    // deleteSticky(issueId, issueTypeData) {
    //     const ctrl = this;
    //     let idx = issueTypeData.findIndex(x => x._id === issueId);
    //     if (idx != -1) {
    //         issueTypeData.splice(idx,1);
    //     }
    // }
    IgnoranceBoardComponent.prototype.setHoveredSticky = function (show, id) {
        var ctrl = this;
        ctrl.options = { show: true, id: id };
    };
    IgnoranceBoardComponent.prototype.showIcons = function (id) {
        var ctrl = this;
        return ctrl.options.show == true && ctrl.options.id == id;
    };
    // deleteItemSticky(issueId) {
    //     const ctrl = this;
    //     let issueData = ctrl.removeAndReturnChangedIgnorance(issueId);
    //     ctrl.deleteSticky(issueId, ctrl.desirability);
    //     ctrl.deleteSticky(issueId, ctrl.feasibility);
    //     ctrl.deleteSticky(issueId, ctrl.viability);
    //     ctrl.deleteSticky(issueId, ctrl.strengths);
    //     ctrl.deleteSticky(issueId, ctrl.weaknesses);
    //     ctrl.deleteSticky(issueId, ctrl.opportunities);
    //     ctrl.deleteSticky(issueId, ctrl.threats);
    //     ctrl.deleteSticky(issueId, ctrl.defaultList);
    //     ctrl.saveIgnorance();
    // }
    IgnoranceBoardComponent.prototype.initDiscoveryImgComponent = function (event, args) {
        var ctrl = this;
        ctrl.title = args.actionMenuItem;
        ctrl.nodeName = args.node.name;
        ctrl.node = args.node;
        ctrl.menu = [];
    };
    IgnoranceBoardComponent.prototype.initComponent = function (event, args) {
        var _a;
        var ctrl = this;
        ctrl.title = args.actionMenuItem;
        ctrl.nodeName = args.node.name;
        ctrl.node = args.node;
        _a = [[], [], [], [], [], [], [], [], [], []], ctrl.items[9] = _a[0], ctrl.items[8] = _a[1], ctrl.items[7] = _a[2], ctrl.items[6] = _a[3], ctrl.items[5] = _a[4], ctrl.items[4] = _a[5], ctrl.items[3] = _a[6], ctrl.items[2] = _a[7], ctrl.items[1] = _a[8], ctrl.items[0] = _a[9];
        ctrl.getDFVandSWOTData();
        ctrl.menu = [];
    };
    IgnoranceBoardComponent.prototype.populateItemList = function (key, data) {
        var ctrl = this;
        data.forEach(function (d) {
            d['color'] = ctrl.issueConfig[key];
            d['type'] = key;
            d['title'] = ctrl.utilsService.returnLimitedTitle(d);
            ctrl.items[d.ignorance].push(d);
        });
    };
    IgnoranceBoardComponent.prototype.getDFVandSWOTData = function () {
        var ctrl = this;
        ctrl.smartorg.getDFVAndSWOTData(ctrl.node._id).then(function (res) {
            if (res) {
                ctrl.initCanvasData(res);
                ctrl.$timeout();
                ctrl.$scope.$apply();
            }
            else {
                ctrl.showAlert('danger', 'Error!', res.message);
                ctrl.saving = false;
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
            ctrl.saving = false;
        });
    };
    IgnoranceBoardComponent.prototype.initCanvasData = function (data) {
        var ctrl = this;
        ctrl.issueConfig = ctrl.utilsService.getIssueConfig(data['CanvasConfig']);
        ctrl.stickyList = data['NColCanvasSwotData'];
        // Iterate objects
        Object.keys(data['NColCanvasSwotData']).forEach(function (key) {
            ctrl.populateItemList(key, ctrl.stickyList[key]);
        });
    };
    IgnoranceBoardComponent.prototype.onSelectSticky = function (list, sticky, index) {
        var ctrl = this;
        ctrl.selectedIssueCopy = JSON.parse(JSON.stringify(sticky));
        ctrl.selectedIssue = sticky;
        ctrl.selectedIssueList = list;
        ctrl.selectedIssue.index = index;
    };
    IgnoranceBoardComponent.prototype.onCloseStickyModal = function () {
        var ctrl = this;
        ctrl.selectedIssueList[ctrl.selectedIssue.index] = JSON.parse(JSON.stringify(ctrl.selectedIssueCopy));
        ctrl.selectedIssue = null;
    };
    IgnoranceBoardComponent.prototype.deleteNode = function () {
        var ctrl = this;
        bootbox.dialog({
            message: "You are about to delete this issue. Are you sure?",
            title: "Confirm Deletion",
            buttons: {
                confirm: {
                    label: "Delete",
                    className: "btn-danger",
                    callback: function () {
                        ctrl.deleteSticky();
                    }
                },
                cancel: {
                    label: "Cancel",
                    className: "btn-primary"
                }
            }
        });
    };
    ;
    IgnoranceBoardComponent.prototype.deleteSticky = function () {
        var ctrl = this;
        ctrl.items[ctrl.selectedIssue.ignorance].splice(ctrl.selectedIssue.index, 1);
        ctrl.selectedIssueList = ctrl.selectedIssueList.splice(ctrl.selectedIssue.index, 1);
        ctrl.saveIgnorance();
        ctrl.selectedIssue = null;
    };
    IgnoranceBoardComponent.prototype.saveIgnorance = function () {
        var ctrl = this;
        var res = [].concat.apply([], ctrl.items);
        var req = {};
        res.forEach(function (x) {
            // init if array not exist
            if (!req[x.type])
                req[x.type] = [];
            req[x.type].push(x);
        });
        ctrl.$timeout(function () {
            ctrl.smartorg.saveDFVAndSWOTData(ctrl.node._id, req).then(function (ret) {
                if ('data' in ret) {
                    var res_1 = ret['data'];
                    ctrl.initCanvasData(res_1);
                    //ctrl.showAlert('success', 'Saved!', 'DFV Data');
                    ctrl.saving = false;
                    ctrl.$timeout();
                    ctrl.$scope.$apply();
                }
                else {
                    // ctrl.showAlert('danger', 'Error!', ret.message);
                    ctrl.saving = false;
                }
            })["catch"](function (err) {
                ctrl.showAlert('danger', 'Error!', err.message);
                ctrl.saving = false;
            });
        }, 500);
        // }
    };
    return IgnoranceBoardComponent;
}());
angular.module('smartorg.r6.acts.ignoranceBoard', []).component('ignoranceBoard', {
    template: require('./ignorance-board.component.html'),
    controller: IgnoranceBoardComponent,
    bindings: {
        smartorg: '=',
        menu: '='
    }
})
    .directive('noteIg', function ($document) {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        template: '<div class="ig-note"><div class="noteBody" ng-transclude></div></div>',
        link: function (scope, element, attr) {
            element.on('dragstart', function (ev) {
                ev.originalEvent.dataTransfer.setData('text/plain', ev.target.id);
                setTimeout(function () {
                    //ev.target.classList.add('hide');
                }, 0);
                scope.$apply();
            });
        }
    };
})
    .directive('landingZone', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), content = _a.content, issueType = _a.issueType, issueId = _a.issueId;
                scope.$emit('Drop0', { 'issue': content, 'type': issueType, '_id': issueId });
            });
        }
    };
})
    .directive('item9', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), content = _a.content, issueType = _a.issueType, issueId = _a.issueId;
                scope.$emit('Drop9', { 'issue': content, 'type': issueType, '_id': issueId });
            });
        }
    };
})
    .directive('item8', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), content = _a.content, issueType = _a.issueType, issueId = _a.issueId;
                scope.$emit('Drop8', { 'issue': content, 'type': issueType, '_id': issueId });
            });
        }
    };
})
    .directive('item7', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), content = _a.content, issueType = _a.issueType, issueId = _a.issueId;
                scope.$emit('Drop7', { 'issue': content, 'type': issueType, '_id': issueId });
            });
        }
    };
})
    .directive('item6', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), content = _a.content, issueType = _a.issueType, issueId = _a.issueId;
                scope.$emit('Drop6', { 'issue': content, 'type': issueType, '_id': issueId });
            });
        }
    };
})
    .directive('item5', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), content = _a.content, issueType = _a.issueType, issueId = _a.issueId;
                scope.$emit('Drop5', { 'issue': content, 'type': issueType, '_id': issueId });
            });
        }
    };
})
    .directive('item4', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), content = _a.content, issueType = _a.issueType, issueId = _a.issueId;
                scope.$emit('Drop4', { 'issue': content, 'type': issueType, '_id': issueId });
            });
        }
    };
})
    .directive('item3', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), content = _a.content, issueType = _a.issueType, issueId = _a.issueId;
                scope.$emit('Drop3', { 'issue': content, 'type': issueType, '_id': issueId });
            });
        }
    };
})
    .directive('item2', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), content = _a.content, issueType = _a.issueType, issueId = _a.issueId;
                scope.$emit('Drop2', { 'issue': content, 'type': issueType, '_id': issueId });
            });
        }
    };
})
    .directive('item1', function () {
    return {
        link: function (scope, element) {
            element.on('dragover', function (event) {
                event.preventDefault();
            });
            element.on('drop', function (ev) {
                var _a = getDropDetails(ev), content = _a.content, issueType = _a.issueType, issueId = _a.issueId;
                scope.$emit('Drop1', { 'issue': content, 'type': issueType, '_id': issueId });
            });
        }
    };
});
module.exports = 'smartorg.r6.acts.ignoranceBoard';
/// line 637 ignorance board
//# sourceMappingURL=ignorance-board.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/ignorance-board/ignorance-board.component.js